{
  "ACTIONS": {
    "CONFIRM": "Confirmer",
    "CONTINUE": "Continuer",
    "SUBMIT": "Envoyer",
    "RETRY": "Réessayer",
    "CANCEL": "Annuler",
    "EMPTY": "Il n'y a rien ici",
    "LOADING_ORDERS": "Préparation de votre addition",
    "CLEAR_ALL": "Tout enlever",
    "AWESOME": "Super!",
    "VIEW_RECEIPT": "Voir mon reçu",
    "ADD_CART": "Ajouter au panier",
    "UPDATE_CART": "Mettre à jour le panier",
    "EDIT": "Modifier",
    "SEARCH_PLACEHOLDER": "Chercher des plats ou restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Il manque certaines options, veuillez les sélectionner avant de continuer",
    "ITEM_UNAVAILABLE": "Ce produit n'est plus disponible",
    "SECTION_NOT_FOUND": "Cette section n'est plus disponible",
    "ITEM_NOT_FOUND": "Ce produit n'est plus disponible",
    "PROMOTION_NOT_AVAILABLE": "Cette promotion n'est plus disponible",
    "REQUIRED": "Requis",
    "COMBO": "Formule",
    "INVALID_EMAIL": "Veuillez saisir une adresse e-mail valide",
    "INVALID_PHONE": "Veuillez saisir un numéro de téléphone valide",
    "FEES": "Frais",
    "MIN_ORDER_ERROR": "Vous devez commander pour {{amount}} {{currency}} afin de placer votre commande",
    "ADD_MIN_ORDER": "Ajoutez {{amount}} {{currency}}  pour pouvoir placer votre commande",
    "CONNECTION_ERROR": "Une erreur est survenue lors du chargement de cette table. Veuillez réessayer.",
    "TABLE_NOT_FOUND": "Nous n'avons pas trouvé cette table. Veuillez scanner à nouveau le QR code."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Nom",
    "ROOM_NUMBER": "Numéro de chambre",
    "SNACKBAR_TITLE": "Nous vous amenons votre addition",
    "PAY_BILL": "Payer l'addition"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Nombre total de personnes à table",
    "PAYING_FOR": "Nombre de personnes pour lesquelles vous payez",
    "REMAINING": "Montant restant",
    "CHEQUE": "Addition",
    "AMOUNT_PAID": "Montant payé",
    "DISCOUNT": "Remise",
    "PROMO": "Promo",
    "FEES": "Frais",
    "PAID_ITEMS": "Articles payés",
    "SPLIT_BILL": "Partager l'addition",
    "EDIT_SPLIT": "Modifier le partage",
    "PAY_BILL": "Payer l'addition",
    "SPLIT_TITLE": "Partager l'addition",
    "SPLIT_SUBTITLE": "Sélectionnez comment vous souhaitez partager l'addition",
    "SPLIT_EVENLY": "Partager équitablement",
    "CUSTOM_AMOUNT": "Montant personnalisé",
    "ADD_CUSTOM_AMOUNT": "Ajouter un montant personnalisé",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Saisissez un montant personnalisé",
    "PAY_FOR_ITEMS": "Payez vos articles",
    "CONFIRM_SELECTION": "Confirmer la sélection",
    "SOMEONE_ELSE_PAYING": "Quelqu'un d'autre à votre table est en train de payer"
  },
  "COMBO": {
    "ADD_N": "Ajouter {{count}} {{section}}",
    "REMOVE_N": "Retirer {{count}} {{section}}",
    "CANNOT_PROCEED": "Veuillez suivre le guide ci-dessus pour compléter votre formule avant de continuer",
    "COMPLETE": "Formule {{combo}} complète !",
    "ON_ANOTHER_SECTION": "Cela fait partie de votre formule {{section}}"
  },
  "CART": {
    "TITLE": "Panier",
    "RECOMMENDATION": "Vous aimerez aussi",
    "TOTAL": "Total",
    "VIEW": "Voir mon panier & Placer ma commande",
    "EMPTY": "Votre panier est vide",
    "PLACE_ORDER": "Placer ma commande",
    "ADD_TO_BILL": "Ajouter à l'addition",
    "PAY_NOW": "Payer maintenant",
    "OOPS": "Oups",
    "ADD_NEW_VARIANT": "Ajouter un autre",
    "VARIANT_TITLE": "Vous avez changé d'avis ?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Souhaitez vous vider votre panier ?",
    "CLEAR": "Vider le panier",
    "ADD_NOTE": "Ajouter une note",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Votre commande a été payé !",
    "ERROR": "Une erreur est survenue lors du paiement, veuillez réessayer",
    "APPLE_PAY_TAP_AGAIN": "Veuillez appuyer à nouveau sur Apple Pay pour continuer",
    "TITLE": "Paiement",
    "PAY_CARD": "Payer",
    "SUCCESSFUL": "Le paiement a réussi",
    "SUMMARY": "Addition",
    "PROGRESS": "Paiement en cours... veuillez patienter",
    "CANCEL": "Merci de ne pas rafraichir la page ou cliquer sur le bouton retour. Si vous souhaitez annuler, veuillez presser le bouton cancel sur la machine."
  },
  "ORDER": {
    "TITLE": "Mes commandes",
    "CONFIRMED": "Confirmé",
    "NOTES": "Ajouter un commentaire",
    "TOTAL": "Total",
    "SUBTOTAL": "Sous-total",
    "ORDER": "Commander",
    "PAID": "Paid",
    "PLACED": "Votre commande a été placé",
    "UNPAID": "Votre commande n'est pas payée",
    "CANCELLED": "Votre commande a été annulée",
    "VOID": "Votre commande a été invalidée",
    "UPDATED": "Votre commande a été mise à jour",
    "ORDERS": "Commandes",
    "PREVIOUS": "Commandes précédente",
    "REJECTED": "Oops ! Un ou plusieurs plats ne sont plus disponible et ont été retirés de votre panier."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Vous recevrez bientôt votre commande",
    "HELP": "Comment pouvons nous aider ?",
    "ADDITIONAL_COMMENTS": "Commentaires"
  },
  "MENU": {
    "SKIP": "Passer",
    "MENU": "Menu",
    "SEARCH": "Rechercher",
    "NO_SEARCH_RESULTS": "Aucun article ne correspond à votre recherche",
    "SEARCH_OTHER_SECTIONS": "Nous avons trouvé des résultats dans d'autres sections",
    "NO_FILTER_RESULTS": "Aucun article ne correspond à vos filtres",
    "CLEAR_FILTERS": "Effacer les filtres",
    "NO_SECTIONS": "Aucune section disponible",
    "STAFF": "Serveur",
    "FILTERS": "Filtres alimentaire"
  },
  "SETTINGS": {
    "TITLE": "Paramètres",
    "LANGUAGE": "Langage",
    "SELECT_LANGUAGE": "Choisissez la langue",
    "CURRENCY": "Devise"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Ajouter a ma note"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Veuillez scanner a nouveau le QR pour continuer votre session",
    "SESSION_EXPIRED": "Votre session a expiré"
  },
  "PICKUP": {
    "TITLE": "Vos renseignements"
  },
  "VOUCHER": {
    "ADD": "Ajouter un coupon",
    "PLACEHOLDER": "Saisissez votre coupon",
    "VOUCHER": "Coupon",
    "DISCOUNTED_AMOUNT": "Total Apres Discount",
    "CURRENT_BALANCE": "Solde",
    "REMAINING_BALANCE": "Solde après achat",
    "AMOUNT_DUE": "Solde du"
  },
  "TIP": {
    "TIP": "Pourboire",
    "ADD": "Ajouter un pourboire",
    "PLACEHOLDER": "Saisissez le montant du pourboire"
  },
  "LANDING": {
    "CALL_WAITER": "Appeler le serveur",
    "VIEW_BILL": "Voir l'addition - ",
    "LOADING_BILL": "Chargement de l'addition"
  },
  "LOADER": {
    "Heading": "Traitement de votre paiement...",
    "Subheading": "Veuillez ne pas fermer cette page. Nous confirmons votre paiement et vous redirigerons automatiquement.",
    "Hint": "Cela prend généralement quelques secondes."
  },
  "NoVoucher": "Bon non disponible",
  "VoucherDisabled": "Ce bon est désactivé",
  "VoucherExpired": "Ce bon a expiré",
  "VoucherAlreadyUsed": "Ce bon a déjà été utilisé",
  "VoucherZeroBalance": "Ce bon a un solde de 0",
  "VoucherUserLimitReached": "Vous avez déjà utilisé ce bon",
  "VoucherFirstOrderOnly": "Ce bon est valable uniquement pour votre première commande",
  "VoucherNotApplicable": "Ce bon ne s'applique pas aux articles de votre commande"
}
